import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Icon
} from 'semantic-ui-react'

const CardQueueDoctorUX = (props: any) => {
    return(
      <div
        id="CardQueueDoctorUX-div-0"
        style={{position:"relative",marginTop: props.openFullScreen ? "40px" : "0px"  }}>
        <div
          id="CardQueueDoctorUX-div-12"
          style={{display:"flex",margin:"10px",}}>
          
          <div
            id="CardQueueDoctorUX-div-26"
            style={{width:"10%"}}>
            {}
            <img
              id="CardQueueDoctorUX-img-27"
              src={props.logo}
              style={{width: "100%", height: "90%"}}>
            </img>
          </div>
          <div
            id="CardQueueDoctorUX-div-14"
            style={{width:"100%"}}>
            
            <div
              id="CardQueueDoctorUX-div-15"
              style={{ display: "flex", justifyContent: "space-between",marginLeft:"5px"}}>
              
              <div
                id="CardQueueDoctorUX-div-18"
                style={{ fontWeight: "bold", fontSize: "18px",alignItems:"center",display:"flex"}}>
                {props.hospital}
              </div>
              <div
                id="CardQueueDoctorUX-div-19"
                style={{ fontWeight: "bold", fontSize: "18px",alignItems:"center",display:"flex"}}>
                {props.date}
              </div>
            </div>
            <div
              id="CardQueueDoctorUX-div-16"
              style={{ border: "1px solid rgb(29, 189, 212)"}}>
              
            </div>
            <div
              id="CardQueueDoctorUX-div-17"
              style={{ display: "flex", justifyContent: "space-between",marginLeft:"5px",marginTop:"5px"}}>
              
              <div
                id="CardQueueDoctorUX-div-20"
                style={{ fontWeight: "bold", fontSize: "17px",alignItems:"center",display:"flex"}}>
                {props.division}
              </div>
              <div
                id="CardQueueDoctorUX-div-21"
                style={{ fontWeight: "bold", fontSize: "17px",alignItems:"center",display:"flex"}}>
                {props.time}
              </div>
            </div>
          </div>
          <div
            id="CardQueueDoctorUX-div-32"
            style={{display: props.openFullScreen ?  "flex" : "none",alignItems:"center",marginLeft:"5px"}}>
            
            <Icon
              className="red large"
              id="CardQueueDoctorUX-Icon-33"
              name={"close"}
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <div
          id="CardQueueDoctorUX-div-29"
          style={{justifyContent:"center",display: "flex"}}>
          
          <div
            id="CardQueueDoctorUX-div-30"
            style={{ backgroundColor: "rgb(29, 189, 212)",borderRadius:"10px",margin:"10px",padding:"10px",width:"20%",position:"absolute",top:"-10px"}}>
            
            <label
              id="CardQueueDoctorUX-label-31"
              style={{  fontWeight: "bold", fontSize: "24px",justifyContent:"center",display: "flex",color:"white"}}>
              {props.languageUX === "en" ? "Waiting line to enter the examination room" : "คิวรอเข้าห้องตรวจ"}
            </label>
          </div>
        </div>
        <div
          id="CardQueueDoctorUX-div-1"
          style={{margin:"0px 10px 10px 10px",zoom:"90%"}}>
          
          <div
            id="CardQueueDoctorUX-div-11"
            style={{display: "grid", gridTemplateColumns: "80% 20%", columnGap: "2px", padding: "0px"}}>
            
            <div
              id="CardQueueDoctorUX-div-35"
              style={{margin:"10px"}}>
              {props.listDoctor}
            </div>
            <div
              id="CardQueueDoctorUX-div-36"
              style={{ backgroundColor: "#FFE6B9",borderRadius:"5px",margin:"10px"}}>
              
              <div
                id="CardQueueDoctorUX-div-39"
                style={{ backgroundColor: "white",borderRadius:"20px",margin:"10px",padding:"10px"}}>
                
                <label
                  id="CardQueueDoctorUX-label-40"
                  style={{  fontWeight: "bold", fontSize: "22px",justifyContent:"center",display: "flex",color:"#026EBC"}}>
                  {props.languageUX === "en" ? "Received test results" : "ได้รับผลตรวจ"}
                </label>
              </div>
              <div
                id="CardQueueDoctorUX-div-41">
                {props.listLab}
              </div>
              <div
                id="CardQueueDoctorUX-div-44"
                style={{display:"flex",margin:"10px",justifyContent:"flex-end"}}>
                
                <div
                  id="CardQueueDoctorUX-div-48"
                  style={{ fontWeight: "bold", fontSize: "20px",alignItems:"center",display:"flex"}}>
                  {props.languageUX === "en" ? "Nubmer of Waiting for Interpretation" : "จำนวนที่รอฟังผลตรวจ"}
                </div>
                <div
                  id="CardQueueDoctorUX-div-49"
                  style={{ backgroundColor: "white",borderRadius:"10px",margin:"10px",padding:"10px",width:"10%"}}>
                  
                  <div
                    id="CardQueueDoctorUX-div-50"
                    style={{ fontWeight: "bold", fontSize: "20px",alignItems:"center",display:"flex",justifyContent:"center",}}>
                    {props.countLab}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardQueueDoctorUX-div-51"
          style={{margin:"0px 10px 10px 10px",backgroundColor:"#FFB4B4"}}>
          
          <div
            id="CardQueueDoctorUX-div-52"
            style={{display:"flex",padding:"10px"}}>
            
            <div
              id="CardQueueDoctorUX-div-53"
              style={{ fontWeight: "bold", fontSize: "20px",marginRight:"5px"}}>
              {props.languageUX === "en" ? "Called through:" : "เรียกผ่านไปแล้ว:"}
            </div>
            <div
              id="CardQueueDoctorUX-div-54"
              style={{width:"70%"}}>
              {props.listCancel}
            </div>
            <div
              id="CardQueueDoctorUX-div-56"
              style={{flex:"1"}}>
              
            </div>
            <div
              id="CardQueueDoctorUX-div-55"
              style={{ fontWeight: "bold", fontSize: "20px",marginRight:"5px"}}>
              {props.languageUX === "en" ? "| Please contact the nurse counter." : "| กรุณาติดต่อเคาเตอร์พยาบาล"}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardQueueDoctorUX

export const screenPropsDefault = {}

/* Date Time : Wed Sep 17 2025 11:56:04 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{position:\"relative\",marginTop: props.openFullScreen ? \"40px\" : \"0px\"  }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"0px 10px 10px 10px\",zoom:\"90%\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"80% 20%\", columnGap: \"2px\", padding: \"0px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",margin:\"10px\",}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\",marginLeft:\"5px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ border: \"1px solid rgb(29, 189, 212)\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\",marginLeft:\"5px\",marginTop:\"5px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.hospital"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\",alignItems:\"center\",display:\"flex\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.date"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\",alignItems:\"center\",display:\"flex\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.division"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"17px\",alignItems:\"center\",display:\"flex\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "code",
          "value": "props.time"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"17px\",alignItems:\"center\",display:\"flex\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{width:\"10%\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "img",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-img-27"
        },
        "src": {
          "type": "code",
          "value": "props.logo"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"90%\"}"
        }
      },
      "seq": 27,
      "void": true
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{justifyContent:\"center\",display: \"flex\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"rgb(29, 189, 212)\",borderRadius:\"10px\",margin:\"10px\",padding:\"10px\",width:\"20%\",position:\"absolute\",top:\"-10px\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "คิวรอเข้าห้องตรวจ",
          "valueEN": "Waiting line to enter the examination room"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-label-31"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\", fontSize: \"24px\",justifyContent:\"center\",display: \"flex\",color:\"white\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{display: props.openFullScreen ?  \"flex\" : \"none\",alignItems:\"center\",marginLeft:\"5px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Icon",
      "parent": 32,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-Icon-33"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.listDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"#FFE6B9\",borderRadius:\"5px\",margin:\"10px\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"white\",borderRadius:\"20px\",margin:\"10px\",padding:\"10px\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "ได้รับผลตรวจ",
          "valueEN": "Received test results"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-label-40"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\", fontSize: \"22px\",justifyContent:\"center\",display: \"flex\",color:\"#026EBC\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "code",
          "value": "props.listLab"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 36,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",margin:\"10px\",justifyContent:\"flex-end\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนที่รอฟังผลตรวจ",
          "valueEN": "Nubmer of Waiting for Interpretation"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"20px\",alignItems:\"center\",display:\"flex\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"white\",borderRadius:\"10px\",margin:\"10px\",padding:\"10px\",width:\"10%\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "code",
          "value": "props.countLab"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-50"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"20px\",alignItems:\"center\",display:\"flex\",justifyContent:\"center\",}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"0px 10px 10px 10px\",backgroundColor:\"#FFB4B4\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",padding:\"10px\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "เรียกผ่านไปแล้ว:",
          "valueEN": "Called through:"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"20px\",marginRight:\"5px\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "code",
          "value": "props.listCancel"
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{width:\"70%\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "| กรุณาติดต่อเคาเตอร์พยาบาล",
          "valueEN": "| Please contact the nurse counter."
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"20px\",marginRight:\"5px\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardQueueDoctorUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 55,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardQueueDoctorUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
